import React from 'react'

const NoContent = () => {
    return (
        <>
            <div className="no-result-found">
                NO RESULTS FOUND
            </div>
        </>
    )
}

export default NoContent